import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../util'
import { MEDIA } from '../../../../constants'

export const RootWrap = styled(Box)(`
	width: 100%;

	&.personaSection1 {display:block;}
	&.personaSection2 {display:none;}
	&.exportToPPT {
		padding:0; width:1200px;

		& .categoryDrivers {
			min-height: 500px;
		    justify-content: flex-start;
			&:before {padding-top:0;}
		}

		& .opportunitiesListing {
			.lhsMenu {display: none;}
			.rte {
				width: 100%;
				border-radius: 0;
				border: 0;
				padding: 0;

			}
			.rte h4 {display: block;}

			li.segmentChild {
				display: flex;
				align-items: flex-start;

				background: #fff;
				border-radius: 0;
			}

			li.segmentChild > ul {
				display: block;
				margin-left: 0;
				margin-bottom: 10px;

				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				line-height: 24px;
				color: #000000;
				width: calc(100% - 180px);
				border-radius: 10px;
				border-width: 1px;
				border-left-width: 4px;
				padding: 14px 14px 14px 35px;
			}
		}
	}

	${exportToPPT_tableCss}

	&.removedExportToPPT .segmentWrap { width:100% !important; }
	
	@media (max-width: ${MEDIA.lg}) {
		padding: 30px 20px 40px;
	}
`)

export const ContentWrap = styled(Box)(`
	// background: #fff;
	// box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
	// margin-left: 141px;
	// border-radius: 2px;
	// width: calc(100% - 141px);
`)

export const Divider = styled(Box)(`
	border-bottom:1px #EEEEEE solid;
	width:calc(100% + 16px);;
	padding-top: 8px;
	margin-left: -8px;
	margin-bottom: 8px;
`)

export const PersonaDescriptionWrapper = styled(Box)(`
	position:relative;
	&.addMinHt {
		min-height: 80px;
	}
`)

export const PersonaTopSection = styled(Box)(
  (props) => `
	display:flex;
	flex-direction:column;
	gap: 16px;
	// margin-bottom: 16px;
	border: 1px solid ${props.color || '#D1D5DB'};
	border-radius: 12px;
	padding: ${props.contentlength ? 1 : 20}px;
	background: #FFF;
`)

export const PersonaTopHeader = styled(Box)(`
	display:flex;
	// gap: 20px;
	align-items: center;
	// flex-wrap: wrap;
	justify-content: space-between;
	padding-right:10px;
`)

export const PersonaIconWrapper = styled(Box)(
  (props) => `
	min-width: 104px;
	min-height: 104px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 20px;
	background: '#F4F6FB';
	// background: ${props.color ? `${props.color}15` : '#F4F6FB'};
	// border: 2px solid ${props.color || '#D1D5DB'};
	& img {
		max-width: 72px;
		max-height: 72px;
	}
`)

export const PersonaTitle = styled(Box)(`
	font-size: 14px;
	font-weight: 600;
	line-height: 1.2;
	background: #F6F6F5;
	padding: 8px 12px;
	border-radius: 10px;
	width: 170px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	color: #000;
`)

export const PersonaDescriptionText = styled(Box)(`
	font-size: 14px;
	line-height: 22px;
	color: #000;
`)

export const PersonaMetaRow = styled(Box)(`
	display: flex;
	flex-wrap: wrap;
	padding: 12px 0 0;
	align-items: center;
	width:100%;
`)

export const PersonaDescriptionInnerWrapper = styled(Box)(`
	// flex: 1 0;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
	height: stretch;
    justify-content: space-evenly;
	width: calc(100% - 200px);
`)

export const PersonaMetaWrapper = styled(Box)(`
	display: flex;
	align-items: center;
	gap: 10px;
	// flex-wrap: wrap;
	width: 100%;
	white-space: nowrap;
`)

export const PersonaMetaLabel = styled(Box)(`
	font-size: 12px;
	font-weight: 600;
	color: #000;
	letter-spacing: 0.02em;
`)

export const PersonaMetaChips = styled(Box)(`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	width:calc(100% - 90px);
`)

export const PersonaChip = styled(Box)(
  (props) => `
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 8px 16px;
	border-radius: 8px;
	border: 1px solid ${props.color || '#D1D5DB'};
	border-width: 1px 3px;
	color: #000;
	font-size: 12px;
	font-weight: 400;

	& span {
  	  background: ${props.color};
	  width: 20px;
	  height: 20px;
	  border-radius: 20px;
	  margin-left: 5px;
	  margin-right: -8px;
	  display: flex;
	  align-items: center;
	  justify-content: center;

	  &:before {
	 	content: '';
		width: 0;
		height: 0;
		border: 6px transparent solid;
		border-top: 0;
		border-bottom-color: #fff;
		border-bottom-width: 7px;
		margin-top: -2px;
	  }

	  &.directionDown {
	  	transform: rotate(180deg);
	  }

	}
`)

export const PersonaDescription = styled(Box)(`
	width:100%;
	font-weight: 400; // 300;
	font-size: 14px;
	display:flex;
	& > div:last-child {
		border-right:0;
		padding-right:0;
		margin-right:0;
	} 
`)

export const PersonaList = styled(Box)(`
	border-right:1px #EEE solid;
	padding-right: 10px;
	margin-right: 10px;
	& b {
		font-weight: 600;
	}
`)

export const SegmentWrap = styled(Box)(`
	width: calc(100% - 0px);
`)

export const SegmentRow = styled(Box)(
  (props) => `
	font-weight: 400; // 300;
	font-size: 14px;
	border-left: 0;
	padding: 10px;
	position: relative;
	min-height: 60px;
	display:flex;
	flex-direction: column;
	justify-content: center;
	${props?.heading &&
		`&:before {
			content: '${props.heading}';
			width: 100%;
			display: flex;
			align-items: start;
			font-weight: 600;
			font-size: 16px;
			padding-top: 28px
		}`
	}
	& .outerText{
		min-width: 32px;
		font-size: 12px;
		margin-left: 6px;
		font-weight: 400; // 300;
	}
`)

export const SegmentRowContent = styled(Box)(`
	display: flex;
	flex-direction:column;
	position: relative;
`)

export const SegmentTitle = styled(Typography)(`
	font-size: 12px;
	font-weight: 400; // 300;
	width: 65px;
	min-width: 100px;
	text-align: right;
	margin-right: 10px;
	line-height: 12px;
`)

export const SegmentSubTitle = styled(Typography)(`
	width: auto;
	min-width: 100px;
	font-weight: 600;
	font-size: 14px;
	line-height: 16px;
	margin: 0 0 0 -10px;
`)

export const BarWrap = styled(Box)(`
	width: 100%;
	&.association {
		background: #F1F1F3;
		border-radius: 0px 20px 20px 0px;
		padding: 4px;
		& .barSlice {
			border-radius: 0px 20px 20px 0px;
			height: 8px !important;
		}
	}
	& .barRoot, .barItemRoot, .barSliceWrap, .barSlice {
		height: 5px !important;
	}
	& .barSlicePercentage, & .barSliceLabel{
		font-size: 12px !important;
	}
`)

export const IssuesWrap = styled(Box)(`
	position: absolute;
	left: calc(100% + 5px);
	display: flex;
	align-items: center;
	& .radio {
		width: 10px;
		height: 10px;
		min-width: 10px;
		min-height: 10px;
		border: 1px solid #7E7E7E;
		margin-right: 4px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		& .box {
			width: 4.5px;
			height: 4.5px;
			min-width: 4.5px;
			min-height: 4.5px;
			background: #7E7E7E;
			border-radius: 50%;
		}
	}
	& .radio-text {
		font-size: 12px;
		font-weight: 400; // 300;
		white-space: nowrap;
	}
`)

export const ComparisonViewWrap = styled(Box)(`
	& .segment-row {
	}
	& .segment-row-content {
		margin-left: -130px;
		padding-right: 40px;
		& .segment-title {
			margin-right: 20px;
		}
		& .barRoot, .barItemRoot, .barSliceWrap, .barSlice {
			height: 20px !important;
		}
	}
`)

export const PropertyListingOutertWrapper = styled(Box)(`
	width:100%;
	display:flex;
	flex-wrap:wrap;
	justify-content:flex-start;
	position:relative;
`)

export const PropertyListingHeading = styled(Box)(`
	font-weight: 600;
	font-size: 16px;
	color: #000;
	margin-top: 28px;
	margin-bottom: 16px;
	width: 100%;
`)

export const PropertyListingtWrapper = styled(Box)(`
	width:100%;

	display: flex;
	gap: 10px;
	padding: 10px 0;
	border-bottom: 1px solid #EEEEEE;
	&:last-child {
		border-bottom: none;
	}
`)
export const PropertyListingtHeading = styled(Box)(`
	font-weight: 400;
	font-size: 14px;
	color: #000;
	width: 120px;
`)

export const PropertyChipsRow = styled(Box)(`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	width: calc(100% - 130px);
`)

export const PropertyChip = styled(Box)(
  (props) => `
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0 12px;
	border-radius: 30px;
	font-size: 14px;
	font-weight: 600;
	// cursor: pointer;
	transition: all 0.2s ease;
	height: 28px;
	line-height: 28px;
	border: 1px solid ${props.categoryColor};
	color: ${props.categoryColor};
	white-space: nowrap;
	
	& span {
	  width: 20px;
	  height: 20px;
	  border-radius: 20px;
	  margin-left: 5px;
	  margin-right: -8px;
	  display: flex;
	  align-items: center;
	  justify-content: center;

	  &:before {
	 	content: '';
		width: 0;
		height: 0;
		border: 6px transparent solid;
		border-top: 0;
		border-bottom-color: blue;
		border-bottom-width: 7px;
		margin-top: -2px;
	  }

	  &.directionDown {
	  	transform: rotate(180deg);
	  }

	  &.direction {
	  	display: none;
	  }
	}

	${props.selected
      ? `
	  		color: white;
			background: ${props.categoryColor};
			& span { background: #ffffffc4; }
			& span:before { border-bottom-color: ${props.categoryColor}; }
		`
      : `
			background: ${props.categoryColor}1A;
			& span { background: ${props.categoryColor}; }
			& span:before { border-bottom-color: #ffffffc4; }

		`
	  }
	
`)

export const PersonaCard = styled(Box)(
  (props) => `
	width: 116px;
	height: 116px;
	display: flex;
	
	background-color: ${props.bgColor};
	border: 4px #F6F6F5 solid;
    border-radius: 8px;
    box-shadow: 0 0 0 1px #E7E7E6;

	margin: 5px;
	
	& span {
		background: linear-gradient(
			135deg,
			rgba(255, 255, 255, 0.4) 0%,
			rgba(0, 0, 0, 0.3) 100%
		);
	    border-radius: 4px;
		padding: 5px;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		color: #FFF;
		font-weight: 600;
		text-transform: uppercase;
		font-size: 13px;
	    line-height: 15px;
	}

	& span:before, & span:after {
		content: '';
		margin: 3px;
		width: 14px;
		height: 7px;
		background-color: #fff;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
	}
	& span:after {
		transform: rotate(180deg);
	}
`)

export const BehaviorListingOuterWrapper = styled(Box)(`
    display: flex;
    flex-wrap: wrap;
`)

export const BehaviorListingWrapper = styled(Box)(`
	width:calc(33.3%);
	padding:10px;
`)

export const BehaviorListingHeading = styled(Box)(
  (props) => `
	font-weight: 600;
	font-size: 14px;
	display: flex;
    align-items: center;

	& span {
		background: ${props?.color || 'none'};
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
		height:40px;
		width:40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		margin-right: 10px;
	}
`
)

export const BehaviorListUl = styled('ul')(`
	width: 100%;
	padding-left: 70px;
`)

export const BehaviorList = styled('li')(`

`)

export const DriversListingOutertWrapper = styled(Box)(`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	padding: 8px 0;
`)

export const OpportunitiesListingOuterWrapper = styled(Box)(`
	padding-top:16px;
`)

export const DriversListingtWrapper = styled(Box)(`
	display: flex;
	align-items: center;
	gap: 16px;
	width: 100%;
	padding: 10px 0;
`)

export const DriversListingTitle = styled(Typography)(`
	font-weight: 400;
	line-height: 20px;
	color: #000;
	font-size: 14px;
	width: 220px;
	flex-shrink: 0;
`)

export const DriversListingBarWrapper = styled(Box)( props => `
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	min-width: 200px;
	width: ${Math.floor(props.maxOuterWidthValue)-10}px;
	background: #F3F4F6;
    border-radius: 12px;

	& .driversBarTrackWrapper {
		flex: 1 1 auto;
		display: flex;
		align-items: center;
		width: 100%;
		max-width: ${Math.floor(props.maxWidthValue)-50 || 0}px;
	}
`)

export const DriversBarTrack = styled(Box)(`
	position: relative;
	width: 100%;
	height: 16px;
	background: #F3F4F6;
	border-radius: 12px;
	overflow: hidden;
	display: flex;
`)

export const DriversBarFill = styled(Box)(
	(props) => `
		height: 100%;
		width: ${props?.width || 0}%;
		// background: ${props?.color};
		border-radius: 12px;
		background: ${props?.color} repeat;
		// background-image: linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAMAAAARSr4IAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAGZQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////lZ9pqAAAACJ0Uk5TAIYUAnsEgjUHVgpzUQsMO2hgPwUJQX4DbhkBiR1yBoBMWaXlGQAAAABuSURBVHicPc7dBgJRGIXh9YpM+jFlZyqSuf+LiqSD2EzKkGHXzMG3Th7eo7UQFBk0g8EgzfmaMSvojaQlH7N+a0MxdSdtfwE7slIJ2POUDA15kEHHnB4GneBupt0zNzPmpXsF0420ygHtVTosgj+enjjFJmH/BQAAAABJRU5ErkJggg==);
		background-size: 16px 16px;
`)

export const DriversPercentLabel = styled(Typography)(`
	font-weight: 600;
	font-size: 13px;
	color: #0F172A;
	padding-left: 5px;
`)

export const DriversListingtDescription = styled(Box)(
	(props) => `
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		// color: ${props?.color || '#4B5563'};
		flex-shrink: 0;
		color: #0F172A;
		text-align: right;
		align-items: center;
		// min-width: 200px;
`)

export const OpportunitiesInnerWrapper = styled(Box)(
  (props) => `
    display: flex;
    
	& div > ul {
		li.segmentChild {
			// width: calc(100% - 220px);
			// margin: 0 0 0 220px;
			padding: 0;
			position: relative;

			display:none;
		}
		li.segmentChild.active-li {
			display:block;
		}
		li.segmentChild > h4 {
			// position: absolute; left : o; top: 0; border-left: 4px transparent solid;
			// width: 180px; border-bottom: 1px solid #E7E7E6; border-radius: 8px; border-left: 5px solid transparent; margin-left:-220px;
		}
		// li.segmentChild > ul { display: none; border: 1px #E7E7E6 solid; border-left: 4px ${props.color} solid;}
		li.segmentChild > ul { border:0px #E7E7E6 solid; border-left: 0px ${props.color} solid;}
		li.segmentChild.show > ul { display: block; }
		li.segmentChild.show > h4 { background #F6F6F5; border-left: 4px ${props.color} solid;}
	}
`)

export const OpportunitiesContentWrapper = styled(Box)(
  (props) => `
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #000000;
	width: calc(100% - 180px);
	border-radius: 10px;

	border: 1px #E7E7E6 solid;
	border-left: 4px ${props.color} solid;
	padding: 14px;

    & b, & strong {
        font-weight: 600;
    }

    & p {
        padding-bottom:10px;
    }

    & > ul {
        list-style-position: outside;
        margin-left: 0px;
        list-style: none;

        > li {
            // background: #FFFFFF;
            border-radius: 4px;
            padding: 30px 0 20px;
            // margin: 20px 0 0;

            &:last-child{
                margin-bottom: 0;
                padding-bottom: 0;
            }

            > ul > li:has(> hr) {display:none;}

            > h4 {
				display:none;
				border-left: 4px ${props.color} solid;
				border-bottom-color: #fff;
				font-weight: 600;
				background: #F6F6F5;
				padding: 7px 8px;
				width: 200px;
				border-top-left-radius: 5px;
				border-bottom-left-radius: 5px;
				margin-top: 10px;
            }

            & > ul {
                margin-left:30px;
                list-style:disc;
                & > li > ul {
                    margin:5px 5px 5px 20px;
                    list-style-type:circle; // new
                }
            }

        }
    }
`)


export const LhsMenuWrapper = styled(Box)(`
	padding: 12px 0;
`)

export const LhsMenu = styled(Box)(
	(props) => `
	color: #000;
	border-radius: 2px;
	font-weight: 400;

	padding: 8px 12px 8px 8px;
	font-size: 14px;
	text-decoration: none;
	display:block;
	position:relative;
	cursor: pointer;

	width: 180px;
	border-bottom: 1px solid #E7E7E6;
    border-left: 4px transparent solid;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
	
	&.nextActive {
		border-bottom-color: #fff;
	}
	&.active {
		border-left: 4px ${props.color || '#000000'} solid;
		border-bottom-color: #fff;
		font-weight: 600;
		background: #F6F6F5;
	}
`)
